import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useForm } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles';
import { useHistory } from 'react-router';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from '../../configuration';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import ResetPasswordActions from '../../../../redux/reducers/resetPassword_reducer/actions';
import { useSelectForgotPassworddStatus } from '../../../../redux/reducers/resetPassword_reducer/selectors';
import { StateStatus } from '../../../../redux/utils/common';
import { InputAdornment } from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';

export default function ForgotForm() {
  const classes = useStyles();
  const { register, watch, errors, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  let watchUsername = watch('username');
  let forgotPasswordStatus = useSelectForgotPassworddStatus();

  const errorSelector = (fieldName: string) => {
    if (fieldName in errors) {
      if (errors[fieldName].type === 'required') {
        return <TranslatedText textMap={Translations.form_error_required} />;
      }
    } else {
      return '';
    }
  };

  const onSubmit = (data: any) => {
    dispatch(ResetPasswordActions.forgotPasswordAction(data.username, history));
  };

  return (
    <div className={clsx(classes.layout)}>
      <Typography
        variant="h5"
        className={clsx(classes.title, 'text-center md:w-full mb-48')}
      >
        <TranslatedText textMap={Translations.recover_title} />
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="username"
          label={<TranslatedText textMap={Translations.form_field_email} />}
          name="username"
          autoComplete="username"
          error={'username' in errors}
          helperText={errorSelector('username')}
          inputRef={register({ required: true })}
          autoFocus
          InputLabelProps={{
            classes: {
              root: classes.inputLabel,
              focused: classes.inputLabelFocus,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment className={classes.inputIcon} position="start">
                <AccountCircle />
              </InputAdornment>
            ),
            classes: {
              focused: classes.notchedOutlineFocus,
              notchedOutline: classes.notchedOutline,
            },
            className: classes.input,
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={
            !watchUsername || forgotPasswordStatus == StateStatus.Pending
          }
          className={classes.submit}
        >
          <TranslatedText textMap={Translations.form_button_recover} />
        </Button>
      </form>
    </div>
  );
}
